"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.bookingQueryAllAwaitingPayments = exports.bookingQueryAllToInvoice = exports.bookingQueryAllToConfirm = void 0;
const endOfToday_1 = __importDefault(require("date-fns/endOfToday"));
const firestore_1 = require("firebase/firestore");
const BookingStatus_1 = require("../BookingStatus");
const InvoiceStatus_1 = require("../InvoiceStatus");
/** All bookings that must be confirmed. */
function bookingQueryAllToConfirm(firestore, tenantId) {
    return (0, firestore_1.query)((0, firestore_1.collection)(firestore, "bookings"), (0, firestore_1.where)("tenantId", "==", tenantId), (0, firestore_1.where)("status", "==", BookingStatus_1.BookingStatus.provisional.name), (0, firestore_1.orderBy)("created", "asc"));
}
exports.bookingQueryAllToConfirm = bookingQueryAllToConfirm;
/** All bookings without an invoice that have a date of today or earlier. */
function bookingQueryAllToInvoice(firestore, tenantId) {
    return (0, firestore_1.query)((0, firestore_1.collection)(firestore, "bookings"), (0, firestore_1.where)("tenantId", "==", tenantId), (0, firestore_1.where)("invoiceStatus", "==", InvoiceStatus_1.InvoiceStatus.none.name), (0, firestore_1.where)("start", "<", (0, endOfToday_1.default)()), (0, firestore_1.orderBy)("start", "asc"));
}
exports.bookingQueryAllToInvoice = bookingQueryAllToInvoice;
/** All bookings with an invoice and an open balance. */
function bookingQueryAllAwaitingPayments(firestore, tenantId) {
    return (0, firestore_1.query)((0, firestore_1.collection)(firestore, "bookings"), (0, firestore_1.where)("tenantId", "==", tenantId), (0, firestore_1.where)("invoiceStatus", "in", [
        InvoiceStatus_1.InvoiceStatus.open.name,
        InvoiceStatus_1.InvoiceStatus.partial.name,
    ]), (0, firestore_1.orderBy)("start", "asc"));
}
exports.bookingQueryAllAwaitingPayments = bookingQueryAllAwaitingPayments;
